"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _Logger = _interopRequireDefault(require("../../shared/Logger"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var logger = new _Logger["default"]('scout:sensors');
/**
 * init sensors
 *
 * @param {*} scout
 */

function init(scout) {
  var opts = scout.options;

  if (!opts.projectName) {
    logger.error('project of options can\'t be empty');
    return;
  }

  var para = {
    // SDK 使用的一个默认的全局变量
    name: 'scout_sensors',
    // 数据接收地址
    server_url: "".concat(opts.serverDomain || 'https://bi-nginxlog.wlmkids.com:4006', "/sa?project=").concat(opts.projectName),
    // 配置分发地址，用神策分析平台需要配置的
    config_url: "".concat(opts.configDomain || 'https://bi-nginxlog.wlmkids.com:4007', "/api/vtrack/config?project=").concat(opts.projectName),
    // sensorsdata.min.js 文件的地址
    sdk_url: opts.sdk_url || '//qdfile.qufenqi.com/sensors/sensors-vtrack.min.js'
  };
  var n = para.name,
      ele = null,
      eleTarget = null;
  window['sensorsDataAnalytic201505'] = n;

  window[n] = window[n] || function ab(a) {
    return function abc() {
      (window[n]._q = window[n]._q || []).push([a, arguments]);
    };
  };

  window[n]['track'] = window[n].call(null, 'track');

  if (!window[n]._t) {
    createScript(para.sdk_url);
    window[n]._t = Date.now();
    window[n].para = para;
  }
}
/**
 * 创建script标签
 *
 * @param {string} url - 标签链接
 * @returns
 */


function createScript(url) {
  var ele = document.createElement('script');
  ele.async = 1;
  ele.src = url;
  var eleTarget = document.getElementsByTagName('script')[0];
  eleTarget.parentNode.insertBefore(ele, eleTarget);
}

var _default = {
  init: init,
  name: 'sensors'
};
exports["default"] = _default;